import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MixpanelModule } from '@barelab/mixpanel';
import { environment } from '../environments/environment';
import { Carousel } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('service-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately',
    }),
    ReactiveFormsModule,
    MixpanelModule.rootConfiguration({
      projectToken: environment.mixpanelProjectToken,
    }),
    ButtonModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: 'googleTagManagerId', useValue: environment.GTMContainerId },
  ],
})
export class AppModule {
  constructor() {
    Carousel.prototype.onTouchMove = () => {};
  }
}
